module.exports = __webpack_public_path__ + "static/media/WEB_57.deed81e0.png";